// src/components/bex-api-context/bex-api-context.tsx
import React from "react";
var defaults = {
    context: {}
};
var BexApiContext = React.createContext(defaults);
var BexApiProvider = function(param) {
    var children = param.children, context = param.context;
    var value = React.useMemo(function() {
        return {
            context: context
        };
    }, [
        context
    ]);
    return /* @__PURE__ */ React.createElement(BexApiContext.Provider, {
        value: value
    }, children);
};
BexApiProvider.displayName = "BexApiProvider";
var useBexApi = function() {
    return React.useContext(BexApiContext);
};
export { BexApiProvider, useBexApi };
//# sourceMappingURL=index.js.map